import MallColor from '@/helpers/MallColor';
import { useLazyMallIsFooter } from '@/store/lazyMallStore';
import { useLoginFormDialogStore } from '@/store/loginFormDialogStore';
import { useVendorStore } from '@/store/vendorStore';
import { Box, Collapse, Divider, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function Footer() {
    const [open, setOpen] = useState(false);
    const isFooter = useLazyMallIsFooter();
    const handleClick = () => {
        setOpen(!open);
    };
    const { vendor } = useVendorStore();

    const params = useParams();
    if (!isFooter) return <></>;

    return (
        <Box>
            {params?.vendorPath ? (
                <MallInfo2
                    mallName={vendor?.vendorBusinessInfo?.storeName || vendor?.nickname || '플로잉'}
                    businessNumber={vendor?.vendorBusinessInfo?.businessRegistrationNumber || ''}
                    sellNumber={vendor?.vendorBusinessInfo?.mailOrderSalesRegistrationNumber || ''}
                    customerCenterNumber={vendor?.vendorBusinessInfo?.customerCenterNumber || ''}
                    address={vendor?.vendorBusinessInfo?.companyAddress || ''}
                    storeLocation={vendor?.vendorBusinessInfo?.storeLocation || ''}
                    ceoName={vendor?.vendorBusinessInfo?.ownerName || ''}
                    managerNumber={vendor?.vendorBusinessInfo?.managerPhoneNumber || ''}
                />
            ) : (
                <MallInfo
                    mallName={'플로잉'}
                    ceoName={'오석환'}
                    businessNumber={'650-86-03029'}
                    sellNumber={'제 2024-서울강동-1600 호'}
                    customerCenterNumber={'070-4505-4055'}
                />
            )}
            <Divider />

            <Box
                display={'flex'}
                onClick={handleClick}
                bgcolor={`${MallColor['box-bg-white']}`}
                padding={'3% 5% 3%'}
                gap="2%"
                sx={{
                    '& :hover': {},
                }}
            >
                <Typography variant="h5">2022 Flowing Corp.</Typography>
                <Typography
                    variant="h5"
                    onClick={(e) => {
                        e.stopPropagation();
                        window.open('https://terms.flowing.tel/terms.html');
                    }}
                >
                    이용약관
                </Typography>
                <Typography
                    variant="h5"
                    onClick={(e) => {
                        e.stopPropagation();
                        window.open('https://terms.flowing.tel/privacy.html');
                    }}
                >
                    개인정보처리방침
                </Typography>
                <Box flexGrow={1} />
                {/* {open ? <MallIcon iconName='up-arrow' size='nav'/> : <MallIcon iconName='down-arrow' size='nav'/>} */}
            </Box>
            <Collapse in={false}>
                <Box>
                    <Typography variant="h5" margin="2% 6%" lineHeight={'1.3rem'}>
                        (주)플로잉스페이스 대표 : 오석환
                        <br />
                        사업자등록번호 : 650-86-03029
                        <br />
                        통신판매번호 : 제 2024-서울강동-1600 호<br />
                        대표번호 : 070-4504-4055
                        <br />
                        주소 : 서울 강동구 길동 천호 대로 1121 일성하이츠
                        <br />
                    </Typography>
                </Box>
            </Collapse>

            <Divider />
        </Box>
    );
}

export default Footer;

function MallInfo({ mallName, ceoName, businessNumber, sellNumber, customerCenterNumber }) {
    return (
        <Box bgcolor={`${MallColor['box-bg-white']}`} sx={{ py: 2 }}>
            <Box display={'flex'} margin="0 5%" padding={'10px 0 0'}>
                <Typography variant="h2" fontWeight={500}>
                    {mallName}
                </Typography>
                <Box flexGrow={1} />
            </Box>
            <Box display={'flex'} margin="0 5% 0">
                <Typography variant="h5">
                    상호명: (주)플로잉스페이스 <br />
                    대표자: {ceoName} <br />
                    사업자등록번호: {businessNumber} | 통신판매번호: {sellNumber} <br />
                    고객센터: {customerCenterNumber} <br />
                    주소 : 서울 강동구 길동 천호 대로 1121 일성하이츠
                </Typography>
            </Box>
        </Box>
    );
}

function MallInfo2({
    mallName,
    businessNumber,
    sellNumber,
    customerCenterNumber,
    address,
    storeLocation,
    ceoName,
    managerNumber,
}) {
    return (
        <Box bgcolor={`${MallColor['box-bg-white']}`} sx={{ py: 2 }}>
            <Box display={'flex'} margin="0 5%" padding={'10px 0 0'} mb={1}>
                <Typography variant="h2" fontWeight={500}>
                    {mallName}
                </Typography>
                <Box flexGrow={1} />
            </Box>
            <Box display={'flex'} margin="0 5% 0">
                <Typography variant="h5">
                    {/* 기본 정보 */}
                    {ceoName && `대표자: ${ceoName}`}
                    {ceoName && storeLocation && ' | '}
                    {storeLocation && `매장위치: ${storeLocation}`}

                    {/* 사업자 정보 */}
                    {(ceoName || storeLocation) && (businessNumber || sellNumber) && <br />}
                    {businessNumber && `사업자등록번호: ${businessNumber}`}
                    {businessNumber && sellNumber && ' | '}
                    {sellNumber && `통신판매번호: ${sellNumber}`}

                    {/* 연락처 정보 */}
                    {(businessNumber || sellNumber) && (customerCenterNumber || managerNumber) && <br />}
                    {customerCenterNumber && `고객센터: ${customerCenterNumber}`}
                    {customerCenterNumber && managerNumber && ' | '}
                    {managerNumber && `담당자 연락처: ${managerNumber}`}

                    {/* 주소 */}
                    {address && (
                        <>
                            <br />
                            {`주소: ${address}`}
                        </>
                    )}
                </Typography>
            </Box>
        </Box>
    );
}
